import { gql } from "@apollo/client";

import type { DraftPreviewButton } from "@/graphql/get-draft-preview";

export const UPDATE_DRAFT_PREVIEW = gql`
  mutation UpdateDraftPreview(
    $instagramUsername: String!
    $hasRedirect: Boolean!
    $redirectUrl: String!
    $hasIntroduction: Boolean!
    $introductionText: String!
    $hasProfileHeader: Boolean!
    $buttons: [ButtonInput!]!
    $hasGallery: Boolean!
    $galleryTitle: String!
    $galleryId: String!
    $galleryRedirect: Boolean!
    $galleryDefaultRedirectUrl: String!
  ) {
    updatePreview(
      instagramUsername: $instagramUsername
      hasRedirect: $hasRedirect
      redirectUrl: $redirectUrl
      hasIntroduction: $hasIntroduction
      introductionText: $introductionText
      hasProfileHeader: $hasProfileHeader
      buttons: $buttons
      hasGallery: $hasGallery
      galleryTitle: $galleryTitle
      galleryId: $galleryId
      galleryRedirect: $galleryRedirect
      galleryDefaultRedirectUrl: $galleryDefaultRedirectUrl
    ) {
      id
      hasRedirect
      redirectUrl
      hasIntroduction
      introductionText
      hasProfileHeader
      buttons {
        url
        text
        enabled
      }
      hasGallery
      galleryTitle
      galleryId
      galleryRedirect
      galleryDefaultRedirectUrl
      updatedAt
    }
  }
`;

export interface UpdateDraftPreviewData {
  updatePreview: {
    id: string;
    hasRedirect: boolean;
    redirectUrl: string;
    hasIntroduction: boolean;
    introductionText: string;
    hasProfileHeader: boolean;
    buttons: DraftPreviewButton[];
    hasGallery: boolean;
    galleryTitle: string;
    galleryId: string;
    galleryRedirect: boolean;
    galleryDefaultRedirectUrl: string;
    updatedAt: string;
  };
}

export interface UpdateDraftPreviewVariables {
  instagramUsername: string;
  hasRedirect: boolean;
  redirectUrl: string;
  hasIntroduction: boolean;
  introductionText: string;
  hasProfileHeader: boolean;
  buttons: DraftPreviewButton[];
  hasGallery: boolean;
  galleryTitle: string;
  galleryId: string;
  galleryRedirect: boolean;
  galleryDefaultRedirectUrl: string;
}
